/* eslint-disable no-unused-vars */
import axios from 'axios'
import Mapper, { mapperMethods } from 'core/mapper'
import Requester from './Requester'

export const apiLimitReturned = 10

export const requesterGlobalMethods = {
  GET_USER_GEOLOCATION: 'getUserGeolocation',
  GET_POINTS_OF_SALES: 'getPointsOfSales',
  GET_POINT_OF_SALES: 'getPointOfSales',
  GET_ZIPCODE_BY_COORDINATES: 'getZipCodeByCoordinates',

  CREATE_CUSTOMER: 'createCustomer',
  CREATE_OPPORTUNITY: 'createOpportunity',
  CREATE_OFFER: 'createOffer',
  CREATE_TRADE_IN: 'createTradeIn'
}

/**
 * The Request class allows you to centralize calls to the outside of the application, including the server
 */
class RequesterGlobal extends Requester {
  /**
   * Réalise des appels vers l'API
   *
   * @param {string} action le nom de l'action à réaliser
   * @param {*} params un objet de paramètres
   * @static
   * @return {Promise} une promesse en général avec les données de retour
   */
  static get = (action, params, redirectMessage) => {
    if (action === requesterGlobalMethods.CREATE_CUSTOMER) {
      const { user } = params

      const {
        civility,
        lastName,
        firstName,
        email,
        zipCode,
        phoneNumber,
        marketingConsent,
        thirdConsent
      } = user

      const { customer } = {
        customer: {
          type: 1,
          civility,
          name: lastName,
          firstname: firstName,
          zipCode,
          cellphone: phoneNumber,
          email,
          marketingConsent: !!marketingConsent,
          thirdConsent: !!thirdConsent
        }
      }

      return RequesterGlobal.post({
        urlApi: 'urlCustomer',
        url: `/customers`,
        params: {
          customer
        },
        redirectMessage
      })
    }

    if (action === requesterGlobalMethods.CREATE_OPPORTUNITY) {
      const { id } = params

      return RequesterGlobal.post({
        urlApi: 'urlSelling',
        url: `/opportunities`,
        params: {
          customerId: id
        },
        redirectMessage
      })
    }

    if (action === requesterGlobalMethods.CREATE_OFFER) {
      const { id } = params

      return RequesterGlobal.post({
        urlApi: 'urlSelling',
        url: `/opportunities/${id}/offers`,
        params: {},
        redirectMessage
      })
    }

    if (action === requesterGlobalMethods.CREATE_TRADE_IN) {
      const { vehicle, furtherInformations, user, comment } = params

      const {
        civility,
        lastName,
        firstName,
        email,
        zipCode,
        phoneNumber,
        phoneNumberPrefixCode,
        marketingConsent,
        thirdConsent,
        isCellphone
      } = user

      const { customer } = {
        customer: {
          type: 1,
          civility,
          name: lastName,
          firstname: firstName,
          zipCode,
          cellphone: isCellphone ? phoneNumber : null,
          cellphonePrefixCode: isCellphone ? phoneNumberPrefixCode : null,
          phone: !isCellphone ? phoneNumber : null,
          phonePrefixCode: !isCellphone ? phoneNumberPrefixCode : null,
          email,
          marketingConsent: !!marketingConsent,
          thirdConsent: !!thirdConsent
        }
      }

      const car = {
        ...Mapper.map(mapperMethods.MAP_VEHICLE, vehicle),
        equipments: [...Mapper.map(mapperMethods.MAP_OPTIONS, vehicle.options)],
        estimatedDamages: { ...Mapper.map(mapperMethods.MAP_ESTIMATED_DAMAGES, vehicle) }
      }

      return RequesterGlobal.post({
        urlApi: 'urlGateway',
        url: `/opportunities/trade-ins`,
        params: {
          customer,
          car,
          furtherInformations,
          comment
        },
        redirectMessage
      })
    }

    if (action === requesterGlobalMethods.GET_POINTS_OF_SALES) {
      const { zipCode, groupCampaign, makeId, dealerCode } = params
      if (makeId && dealerCode) {
        return RequesterGlobal.getRequest({
          urlApi: 'urlIdentity',
          url: `point-of-sales`,
          params: {
            makeIds: [makeId],
            dealerCodes: [dealerCode],
            extendToLink: true
          },
          redirectMessage
        })
      }

      return RequesterGlobal.getRequest({
        urlApi: 'urlIdentity',
        url: `point-of-sales`,
        params: {
          extendToLink: groupCampaign,
          noContextRestriction: groupCampaign,
          zipCode
        },
        redirectMessage
      })
    }

    if (action === requesterGlobalMethods.GET_USER_GEOLOCATION) {
      const { zipCode } = params

      return RequesterGlobal.getRequest({
        urlApi: 'urlGeocoding',
        url: `addresses/zip-codes/${zipCode}/coordinates`,
        params: {},
        redirectMessage,
        rawError: true
      })
    }

    if (action === requesterGlobalMethods.GET_ZIPCODE_BY_COORDINATES) {
      const { latitude, longitude } = params

      return RequesterGlobal.getRequest({
        urlApi: 'urlGeocoding',
        url: `addresses/coordinates/${latitude}/${longitude}/zip-code`,
        params: {},
        redirectMessage,
        rawError: true
      })
    }

    if (action === requesterGlobalMethods.GET_POINT_OF_SALES) {
      const { id } = params
      return RequesterGlobal.getRequest({
        urlApi: 'urlIdentity',
        url: `point-of-sales/${id}`,
        params: {},
        redirectMessage
      })
    }

    return null
  }
}

export default RequesterGlobal
